import { useIntercom } from 'react-use-intercom';
import { useGetProfile } from 'hooks/api/login';
import { useRole } from 'hooks/common/useRole';

enum BootParams {
  accountType = 'Auth.user',
  application = 'ETZ Employer Panel',
}

type UseIntercomChat = {
  registerChat?: () => Promise<void>;
  showChat?: () => Promise<void>;
  logoutIntercom?: () => void;
  showLauncher?: () => void;
};

export const useIntercomChat = (): UseIntercomChat => {
  const { isAdmin } = useRole();

  if (isAdmin)
    return {
      registerChat: undefined,
      showChat: undefined,
      logoutIntercom: undefined,
      showLauncher: undefined,
    };

  const { boot, show, shutdown: logoutIntercom, update } = useIntercom();
  const { data: profile } = useGetProfile();

  const registerChat = async () => {
    await logoutIntercom();
    if (profile) {
      await boot({
        name: profile?.displayName,
        email: profile?.email,
        customAttributes: {
          employerName: profile?.companyName,
          profileStatus: profile?.profileStatus,
          accountType: BootParams.accountType,
          application: BootParams.application,
          hide_default_launcher: true,
        },
      });
    } else {
      await boot({
        customAttributes: {
          hide_default_launcher: true,
        },
      });
    }
  };

  const showLauncher = (): void => {
    update({
      customAttributes: {
        hide_default_launcher: false,
      },
    });
  };

  const showChat = async () => {
    await registerChat();
    showLauncher();
    show();
  };

  return {
    registerChat,
    showChat,
    showLauncher,
    logoutIntercom,
  };
};
